export default __webpack_public_path__ + "static/dome-5660652fadf854ca068799855602cb20.png";